import { render, staticRenderFns } from "./EditarStockFormItem.vue?vue&type=template&id=f944dc86&"
import script from "./EditarStockFormItem.vue?vue&type=script&lang=js&"
export * from "./EditarStockFormItem.vue?vue&type=script&lang=js&"
import style0 from "./EditarStockFormItem.vue?vue&type=style&index=0&id=f944dc86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports